import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const YardAuditWizardRoute: RouteType = {
  name: "YardAuditWizard",
  path: "/workflows/yard-audit",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Yard Audit & Cycle Count",
      component: () => import("./YardAuditWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./YardAuditWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const yardInventoryItemsStore = rootStore.yardInventoryItemsStore as ServiceStore;
      const yardLocationsStore = rootStore.yardLocationsStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;

      await Promise.all([
        yardInventoryItemsStore?.find(),
        yardLocationsStore?.find(),
        panelStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for yard audit:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).yardAuditWizardStore;
    store?.reset();
  },
};

export default YardAuditWizardRoute;